import { render, staticRenderFns } from "./lesson-list.vue?vue&type=template&id=5d8d9fce"
import script from "./lesson-list.vue?vue&type=script&lang=ts"
export * from "./lesson-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports